import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';
import DonationReceipt from '../components/DonationReceipt';

export default function DonationReceiptPage() {
  const { t } = useTranslation();
  const { txnId } = useParams();
  const [donation, setDonation] = useState(null);
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([
      API.get(`/donations/check/${txnId}`),
      API.get('/settings'),
    ]).then(([donationRes, settingsRes]) => {
      if (donationRes.data.status !== 'success') {
        setError(t('receiptPage.notAvailable'));
      } else {
        setDonation(donationRes.data);
      }
      setSettings(settingsRes.data || {});
      setLoading(false);
    }).catch(() => {
      setError(t('receiptPage.notFound'));
      setLoading(false);
    });
  }, [txnId, t]);

  return (
    <div className="receipt-page">
      <div className="receipt-page-toolbar no-print">
        <Link to="/" className="btn btn-outline btn-sm">{t('receiptPage.backToWebsite')}</Link>
        {donation && <button type="button" className="btn btn-primary btn-sm" onClick={() => window.print()}>{t('receiptPage.printReceipt')}</button>}
      </div>

      {loading ? (
        <div className="loader"><div className="spinner" /></div>
      ) : error ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#888' }}>
          <div style={{ fontSize: '3rem', marginBottom: 12 }}>🧾</div>
          <p>{error}</p>
        </div>
      ) : (
        <DonationReceipt donation={donation} settings={settings} />
      )}
    </div>
  );
}
